import {
  DigitalDimensionsStoryblok,
  DimensionsStoryblok,
  RichtextStoryblok,
} from '../../../types/generated-storyblok';
import { UnitsOfMeasure } from '../../../types/Locations';
import { cmToIn } from '../../../utils/product';

export const getDimensionsFormat = (
  dimension: DimensionsStoryblok | DigitalDimensionsStoryblok,
  unit: UnitsOfMeasure | 'PX',
): {
  displayString: string;
  displayStringAlt?: RichtextStoryblok;
} => {
  const isDigital = dimension.component === 'digitalDimensions';

  const hasDiameter = isDigital ? false : dimension.diameter || false;
  const height = parseFloat(
    isDigital ? dimension.heightInPixels || '0' : dimension.heightCM || '0',
  );
  const width = parseFloat(
    isDigital ? dimension.widthInPixels || '0' : dimension.widthCM || '0',
  );
  const depth = isDigital ? 0 : parseFloat(dimension.depthCM || '0');
  const freeText = isDigital ? undefined : dimension?.FreeTextDimensions;

  const dimensions = {
    height: unit === 'IN' ? cmToIn(height) : height,
    width: unit === 'IN' ? cmToIn(width) : width,
    depth: unit === 'IN' ? cmToIn(depth) : depth,
  };

  const relevantDimensions = Object.fromEntries(
    Object.entries(dimensions).filter(
      ([, value]) => Number.isFinite(value) && value !== 0,
    ),
  );

  const displayNames = {
    height: 'H',
    width: 'W',
    depth: 'D',
  } as const;

  const displayUnits = {
    IN: 'in',
    CM: 'cm',
    PX: 'px',
  } as const;

  const displayDimensions = Object.entries(relevantDimensions)
    .map(([key, value]) => {
      const dimensionKey = key as keyof typeof displayNames;
      return `${value.toFixed(unit === 'PX' ? 0 : 1)} (${
        displayNames[dimensionKey]
      })`;
    })
    .join(' × ');

  const withUnit = displayDimensions
    ? `${displayDimensions} ${displayUnits[unit]}`
    : '';

  return {
    displayString: hasDiameter && withUnit ? `⌀ ${withUnit}` : withUnit,
    displayStringAlt: freeText,
  };
};
